// @flow

import { connect } from 'react-redux';
import CovidPage from './covidPage';

const mapStateToProps: Object = state => ({
  brand: state.brand,
  contentfulData: state.contentfulData,
});

export default connect(mapStateToProps, {})(CovidPage);
